import React, { useEffect } from 'react';
import { classNames } from '../utils';

const Input = ({ type, label, value, onValueChange, placeholder, maxLength, disabled, required, prepend, append, className }) => {
	const ref = React.useRef(null);

	useEffect(() => {
		const el = ref.current;

		const handleFocus = () => {
      try {
        if (el) el.showPicker();
      } catch (error) {
        // console.log("Se bloqueó showPicker por falta de interacción previa:", error);
      }
    };

		if (['date','time'].includes(type)) {
			el?.addEventListener('focus', handleFocus);
		}

		return () => {
			if (el) el?.removeEventListener('focus', handleFocus);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={classNames('w-full', className?.base || '')}>
			{!!label && (
				<p className={classNames('mb-1 text-text', className?.label || '')}>{ label }</p>
			)}
			<div className={classNames('flex items-center gap-x-4 border border-gray6 bg-white h-10 w-full rounded-full px-5 py-3', className?.wrapper || '')}>
				{prepend}
				<input
					ref={ref}
					type={type || 'text'}
					className={classNames('flex-1 outline-none border-none bg-transparent w-full disabled:text-gray6', className?.input || '')}
					placeholder={placeholder}
					value={value}
					onChange={e => onValueChange(e.target.value)}
					maxLength={maxLength}
					disabled={disabled}
					required={required}
				/>
				{append}
			</div>
		</div>
	);
}

export default Input;